import React from 'react';
import PropTypes from 'prop-types';
import { BranchShape } from '../../common/react/Shapes';

const BranchResult = props => {
  const {
    branch: { name },
    className = '',
    onClick,
    children
  } = props;

  const classes = className + ' branch-login-result';

  return <div className={classes} onClick={onClick}>
    {name} {children}
  </div>;
};

BranchResult.propTypes = {
  branch: BranchShape.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string
};

export default BranchResult;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/BranchResult.js
 **/